var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1992 3.59407H4.79922C3.91522 3.59407 3.19922 4.31007 3.19922 5.19407V19.5941C3.19922 20.4781 3.91522 21.1941 4.79922 21.1941H19.1992C20.0832 21.1941 20.7992 20.4781 20.7992 19.5941V5.19407C20.7992 4.31007 20.0824 3.59407 19.1992 3.59407ZM18.1504 11.1733C18.0464 11.1829 17.9416 11.1893 17.836 11.1893C16.64 11.1893 15.5888 10.5749 14.9768 9.64447C14.9768 12.0837 14.9768 14.8597 14.9768 14.9061C14.9768 17.0541 13.2352 18.7949 11.088 18.7949C8.94082 18.7941 7.19922 17.0525 7.19922 14.9053C7.19922 12.7573 8.94082 11.0165 11.088 11.0165C11.1696 11.0165 11.2488 11.0237 11.328 11.0285V12.9453C11.248 12.9357 11.1704 12.9213 11.088 12.9213C9.99202 12.9213 9.10322 13.8101 9.10322 14.9061C9.10322 16.0021 9.99122 16.8909 11.088 16.8909C12.1848 16.8909 13.1528 16.0269 13.1528 14.9309C13.1528 14.8869 13.172 5.99487 13.172 5.99487H15.0032C15.1752 7.63247 16.4976 8.92527 18.1504 9.04367V11.1733Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokW);
export default __webpack_public_path__ + "static/media/tiktok-w.535a266d33cbdb94fcd6af12cc1db039.svg";
export { ForwardRef as ReactComponent };